import {
  LegalLayout,
  Section,
  SubList,
} from "../components/legal/LegalLayout";

export default function Refunds() {
  return (
    <LegalLayout
      title="Refund & Cancellation Policy"
      updated="August 11, 2026"
      pageTestId="page-refunds"
    >
      <Section title="1. Company details">
        <SubList
          items={[
            "Legal name: IVORY PULSE SRL",
            "Registration (CUI): 52619680",
            "Contact: support@ivory-pulse.com",
            "Registered office: Romania",
          ]}
        />
      </Section>

      <Section title="2. Scope">
        <p>
          This Refund &amp; Cancellation Policy applies to Pulse One —
          Founders Edition pre-orders and, once delivered, to the Pulse One
          wearable companion. It describes the circumstances in which you may cancel
          your reservation or request a refund, and how we process them.
        </p>
        <p>
          Until payments are enabled, the Ivory Pulse site is{" "}
          <strong>waitlist-only</strong>. No money is collected and no refund
          is due for joining the waitlist — you may leave the list at any
          time by emailing us. The final Refund &amp; Cancellation Policy
          will be published on this page <strong>before</strong> checkout
          opens, so you can review the exact terms before any payment is
          taken.
        </p>
      </Section>

      <Section title="3. Before your unit ships">
        <p>
          Once the pre-sale opens and your reservation becomes a paid pre-order,
          you may request cancellation and a refund at any time before your
          unit enters our fulfilment pipeline, subject to the final policy we
          will publish when payments are enabled. In that case, we will refund
          the amount you paid for the pre-order, less any third-party
          transaction fees we are unable to recover.
        </p>
      </Section>

      <Section title="4. After delivery — EU 14-day right of withdrawal">
        <p>
          Where you buy Pulse One as a consumer in a jurisdiction that
          provides a statutory right of withdrawal (for example, under EU
          consumer law), you generally have the right to withdraw from the
          purchase within <strong>14 days</strong> of receiving the product,
          without giving a reason, unless a legal exception applies.
        </p>
        <SubList
          items={[
            "Notify us within 14 days of delivery by emailing support@ivory-pulse.com with your order reference and the words “withdrawal request”.",
            "Return the product to the return address we provide, in its original packaging where possible, and in reasonable condition.",
            "You are responsible for the return shipping unless we explicitly agree otherwise.",
            "We will refund the price of the product after we receive and inspect the returned unit.",
          ]}
        />
        <p>
          Some statutory exceptions may apply (for example to sealed items
          unsealed after delivery for health or hygiene reasons, or to goods
          made to your specification). Where an exception applies, we will
          inform you in writing.
        </p>
        {/*
          EU digital withdrawal-button readiness note (kept in-page for
          launch clarity — hidden from non-EU copy once that regulation is in
          effect). Before or around 19 June 2026, if Ivory Pulse is actively
          selling to EU consumers, the website is expected to include an
          easy-to-use digital withdrawal / cancellation function where
          legally required. The internal task is tracked by the engineering
          team and will be published as a live widget before payments are
          enabled for EU buyers.
        */}
        <p className="text-white/60 text-sm">
          <em>
            EU readiness note: from on or around 19 June 2026, where Ivory
            Pulse is actively selling to EU consumers, we expect to provide a
            one-click digital cancellation / withdrawal function directly on
            this website where legally required. It will be published before
            payments open for EU buyers.
          </em>
        </p>
      </Section>

      <Section title="5. Product condition on return">
        <p>
          To qualify for a refund under the right of withdrawal, the product
          must be returned in reasonable condition, showing only the handling
          necessary to establish its nature, characteristics and functioning.
          We may reduce the refund to reflect any diminished value resulting
          from handling beyond that.
        </p>
      </Section>

      <Section title="6. Defective, damaged or non-conforming units">
        <p>
          If your Pulse One arrives damaged, defective or materially
          different from what was described at pre-order, please contact
          support@ivory-pulse.com within a reasonable period after delivery. We
          will, at our discretion and in accordance with applicable consumer
          law, arrange repair, replacement, or a refund.
        </p>
      </Section>

      <Section title="7. Digital / AI service access">
        <p>
          The <strong>core Pulse AI companion experience</strong> is provided
          as an ongoing service. Lifetime core AI access offered to Founders
          Edition purchasers is tied to the Pulse One hardware and
          reasonable continued operation of the service, and is subject to
          fair-use thresholds, abuse prevention, service availability and our
          Terms &amp; Conditions. Refunds for a physical pre-order are not
          conditional on ongoing cloud-service uptime commitments, and lifetime
          access does not create a cash-refundable entitlement independent of
          the hardware.
        </p>
      </Section>

      <Section title="8. How refunds are processed">
        <p>
          When a refund is due, we process it to the original payment method
          via our payment provider. Banks typically credit refunds within
          5–10 business days after we initiate them, but exact timing depends
          on your card issuer or bank. We will publish a more precise
          service-level commitment before payments open.
        </p>
      </Section>

      <Section title="9. How to contact us">
        <p>
          For any cancellation or refund request, please email{" "}
          <a
            className="underline decoration-white/30 hover:decoration-white"
            href="mailto:support@ivory-pulse.com"
          >
            support@ivory-pulse.com
          </a>{" "}
          with your order reference. Please include your full name and the
          email used at checkout.
        </p>
      </Section>

      <Section title="10. Updates to this policy">
        <p>
          The final Refund &amp; Cancellation Policy will be published on
          this page before payments open, and will take precedence at the
          moment you place a pre-order or purchase.
        </p>
      </Section>
    </LegalLayout>
  );
}
